import { AppBar, Tabs, Tab } from "@material-ui/core";
import { TabPanel, useTabStyle } from "App/Component/ui";
import { useState } from "react";
import TabHistory from "./TabHistory";
import TabHistoryAsha from "./TabHistoryAsha";
import TabProfile from "./TabProfile";
import React from "react";

export function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export const TabMasterSEP = ({ formData, noBpjs }) => {
  const classes = useTabStyle();
  const [value, setValue] = useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <div>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            variant='fullWidth'
            aria-label='Tabs Jenis Asuransi'
            className='custom-tabs'
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab className='custom-tab' label='PROFILE' {...a11yProps(0)} />
            <Tab
              className='custom-tab'
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='HISTORY'
              {...a11yProps(1)}
            />
            {/* <Tab
              className='custom-tab'
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='HISTORY ASHA'
              {...a11yProps(2)}
            /> */}
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          <TabProfile formData={formData} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TabHistory noBpjs={noBpjs} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <TabHistoryAsha />
        </TabPanel>
      </div>
    </div>
  );
};
